export default __webpack_public_path__ + "static/media/invite_clinicians.6bb0aa63.svg";